import { render } from "./Nico.vue?vue&type=template&id=c0181246&scoped=true"
import script from "./Nico.vue?vue&type=script&lang=js"
export * from "./Nico.vue?vue&type=script&lang=js"

import "./Nico.vue?vue&type=style&index=0&id=c0181246&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0181246"]])

export default __exports__